const DEV = "dev.layer.ai";
const DEV2 = "dev2.layer.ai";
const APP = "app.layer.ai";

export interface EnvConfig {
  /** Public PostHog project API key for the matching stack (used for the next-app rollout flag). */
  posthogKey: string;
  nextAppUrl: string;
}

const EnvConfigs: Record<string, EnvConfig> = {
  [DEV]: {
    posthogKey: "phc_A67BeEAAt9CYEeNK3BZZCJRpxYNMo5YxN5M8Hb2DnLMr",
    nextAppUrl: "https://next.dev.layer.ai",
  },
  [DEV2]: {
    posthogKey: "phc_vFaU6kVGSM4duNDgmJYMYrqt6zuDSJXdpdDPknD9HNxb",
    nextAppUrl: "https://next.dev2.layer.ai",
  },
  [APP]: {
    posthogKey: "phc_pw9H5YMECXjh5CctgPMmRzH3nPJxNnVAUXDhCtwwS2Ab",
    nextAppUrl: "https://next.app.layer.ai",
  },
};

export const getEnv = (): EnvConfig => {
  const { hostname } = window.location;
  // The legacy app is also served at legacy.<stack>.layer.ai; configs are keyed by stack domain.
  const stackDomain = hostname.startsWith("legacy.")
    ? hostname.slice("legacy.".length)
    : hostname;
  if (EnvConfigs[stackDomain]) {
    return EnvConfigs[stackDomain];
  }
  // Unrecognized layer.ai hosts get the production config so prod traffic never
  // points at a dev stack; anything else (localhost, previews) is a dev environment.
  return stackDomain.endsWith(".layer.ai") ? EnvConfigs[APP] : EnvConfigs[DEV];
};

/**
 * Login URL for the next app. `returnTo` is a next-app-relative path
 * ("/acme/workflows/123") the user lands on after the auth handshake —
 * the login route only honors relative paths, so full URLs are ignored.
 */
export const getNextAppLoginUrl = (returnTo?: string): string => {
  const url = new URL("/api/auth/login", getEnv().nextAppUrl);
  if (returnTo) {
    url.searchParams.set("returnTo", returnTo);
  }
  return url.toString();
};
